import useWindowDimensions from '@/components/Hooks/WindowDimension';
import QueryResult from '@/components/QueryResult/query-result';
import {
  useGetBookingTimesQuery
} from '@/graphql/graphql';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { selectHomepage, setOpenModal } from '@/redux/state/homepage';
import 'moment/locale/ar';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Container, Modal, ModalFooter, Row } from 'reactstrap';
import BookingTimeCard, { NoBookings } from '../../Cards/BookingTimeCard';


const pickService_t_prefix = "pages.homePage.pickService";

function BookingDateModal() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { openModals } = useAppSelector(selectHomepage);
  const { bookingTime } = openModals;
  const { loading, error, data } = useGetBookingTimesQuery();
  const { width } = useWindowDimensions()

  const isMobile = width < 991

  const toggleBookingTimeModal = (isOpen: boolean) =>
    dispatch(setOpenModal({ modal: "bookingTime", isOpen }));

  return (
    <>
      <Modal
        isOpen={bookingTime && isMobile}
        toggle={() => toggleBookingTimeModal(false)}
        className="booking-modal"
      >
        <div className="modal-header justify-content-center">
          <button
            aria-hidden={true}
            className="close"
            onClick={() => toggleBookingTimeModal(false)}
            type="button"
          >
            <i className="now-ui-icons ui-1_simple-remove"></i>
          </button>
          <h4 className="title title-up">
            {t(`${pickService_t_prefix}.bookingTime`)}
          </h4>
        </div>
        <div className="modal-body">
          <Container>
            <Row xs="1" sm="1" md="3">
              <QueryResult loading={loading} error={error} data={data}>
                {data && data.availableTimes && data.availableTimes.length > 0 ? <BookingTimeCard data={data} /> : <NoBookings />}
              </QueryResult>
            </Row>
          </Container>
        </div>
        <ModalFooter>
          <Button
            color="danger"
            onClick={() => toggleBookingTimeModal(false)}
            style={{ margin: "0 auto" }}
          >
            {t(`${pickService_t_prefix}.close`)}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default BookingDateModal;